import {createAction, props} from '@ngrx/store';
import {ContactOutputInterface, ContactPagedResponse, ShortConactInterface} from '@app/marketplace/checkout/_models/contact.model';
import {ResponseBaseModel} from '@app/marketplace/core/models/response.model';
import {CheckoutInterface, CheckoutResponse} from '@app/marketplace/checkout/_models/checkout.model';
export const LOADING_CHECKOUT = '[CHECKOUT] Loading checkout';
export const GET_CHECKOUT = '[CHECKOUT] Get checkout';
export const UPDATING_CONTACT_BY_DEFAULT = '[CHECKOUT] Updating contact by default';
export const CANCEL_CHECKOUT_REQUEST = '[CHECKOUT] Cancel request';
export const ERROR_CHECKOUT_REQUEST = '[CHECKOUT] Checkout request error';
export const CLEANING_CHECKOUT = '[CHECKOUT] Cleaning checkout';
export const LoadingCheckout = createAction(
  LOADING_CHECKOUT,
  props<{payload: any}>()
);
export const GetCheckout = createAction(
  GET_CHECKOUT,
  props<{ data: CheckoutResponse}>()
);
export const UpdatingContactByDefault = createAction(
  UPDATING_CONTACT_BY_DEFAULT,
  props<{ contactId: string}>()
);
export const CancelCheckoutRequest = createAction(CANCEL_CHECKOUT_REQUEST);
export const ErrorCheckoutRequest = createAction(ERROR_CHECKOUT_REQUEST);
export const CleaningCheckout = createAction(CLEANING_CHECKOUT);
